<template>
  <section class="wrapper_type_2">
    <b-navbar
      class="horizontal_nav_bar"
      :class="collapseNavbar ? 'opened' : ''"
    >
      <b-navbar-brand
        href="#"
        class="hamburger_container"
        :style="[
          statusInfo.status && statusInfo.status == 1
            ? { marginRight: '50px !important' }
            : null,
        ]"
      >
        <span class="hamburger_span_div" @click="toggleCollapsibleNavBar">
          <div class="span-toggler-bar bar1"></div>
          <div class="span-toggler-bar bar2"></div>
          <div class="span-toggler-bar bar3"></div>
        </span>
      </b-navbar-brand>

      <div style="margin: 0 auto; margin-right: 10%" class="m-hide"></div>

      <b-collapse id="nav-collapse" is-nav>
        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 1"
          class="payment_due_text"
        >
          <span class="text-black"> YOUR SUBSCRIPTION WILL EXPIRE in </span
          ><span class="payment_due_date">{{
            timeSince(new Date(statusInfo.dateDue))
          }}</span
          >, PLEASE MAKE PAYMENT
        </b-nav-item>
        <b-nav-item
          href="#"
          v-if="statusInfo.status && statusInfo.status == 2"
          class="payment_due_text"
        >
          YOUR SUBSCRIPTION HAS EXPIRED, PLEASE MAKE PAYMENT
        </b-nav-item>

        <b-navbar-nav class="ml-auto">
          <!-- SELECT LANGUAGE -->
          <div>
            <select
              @change="changeLanguage"
              v-model="usedLang"
              class="w-100 mb-3 mb-md-3 mb-sm-5 mb-lg-0"
            >
              <option value="fr">FR</option>
              <option value="en">EN</option>
            </select>
            <!-- <select
              @change="changeLanguage"
              class="w-lg-100 mb-3 mb-md-3 mb-lg-0 mr-3"
            >
              <option disabled value="">
                {{ $t("text.cMasterLayout.selectLanguage") }}
              </option>
              <option value="fr">FR</option>
              <option value="en">EN</option>
            </select> -->
          </div>

          <b-nav-item
            href="#"
            class="bell_noti"
            style="position: relative"
            v-if="statusInfo.status && statusInfo.status !== 0"
            @click="showNotification"
          >
            <img src="@/assets/img/notification.svg" width="28" />
          </b-nav-item>
          <b-nav-item href="#"
            ><img v-if="companyIcon" :src="companyIcon" height="30px" />
            <img
              v-if="!companyIcon"
              src="@/assets/img/avatar.svg"
              height="30px"
            />
          </b-nav-item>
          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><span>{{ userName }}</span> &#x25bc;</b
              >
            </template>
            <b-dropdown-item href="#"
              ><router-link :to="{ name: 'companyProfile' }"
                >Profile</router-link
              ></b-dropdown-item
            >
            <b-dropdown-item href="#" @click="signOutUser"
              >Sign Out</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="masterLayoutWrapper" :class="collapseNavbar ? 'opened' : ''">
      <section class="main_content">
        <transition name="moveInUp" mode="out-in" appear>
          <div class="slot_div inner_main_content" ref="inner_main_content">
            <slot>
              <router-view />
            </slot>
          </div>
        </transition>
      </section>
    </div>

    <section
      class="sidebar use-tiny-scroll"
      :class="collapseNavbar ? 'collapsed' : ''"
      @mouseover="toggleSidenavText"
      @mouseleave="hideTitles"
    >
      <div class="mt-3 text-right m-hide-icon">
        <img
          src="@/assets/img/close_btn.png"
          width="35px"
          height="35px"
          @click="toggleCollapsibleNavBar"
          id="mySidenav"
        />
      </div>
      <div class="text-center">
        <div class="company-logo-wrapper">
          <img
            src="@/assets/img/ep-logo.svg"
            class="lg m-hide-icon company-logo"
            width="153"
          />
        </div>

        <div class="mobile-user-details">
          <div class="mt-3 text-right logo_section">
            <img
              src="@/assets/img/close_btn.png"
              width="35px"
              height="35px"
              @click="toggleCollapsibleNavBar"
            />
          </div>
          <div class="mt-3 text-center dasboard_type_button_section">
            <div class="mobile_epump_logo">
              <img src="@/assets/img/mobieli_white_epump_logo.svg" width="20" />
            </div>
            <h6 class="mt-2 text-white">{{ userName }}</h6>
            <small class="mt-2 text-white">{{ userDetails.email }}</small>
          </div>
        </div>
      </div>
      <div class="mt-3 dasboard_type_button_section"></div>

      <div class="mt-4 mb-4 menu-wrapper">
        <ul class="list-group" style="">
          <li
            class="list-group-item"
            :class="
              activeRoute === 'pos-owner-transactions'
                ? 'navbar_item_active'
                : ''
            "
          >
            <router-link
              :to="{ name: 'pos-owner-transactions' }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/money-transfer.svg" width="20px"
              /></span>
              <span class="sidenav_list_title"> POS Transactions </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="
              activeRoute === 'pos-owner-terminals' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{ name: 'pos-owner-terminals' }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/briefcase.svg" width="20px"
              /></span>
              <span class="sidenav_list_title"> POS Terminals </span>
            </router-link>
          </li>

          <li
            class="list-group-item m-view vue_router_link"
            @click="signOutUser"
          >
            <a href="" class="vue_router_link">
              <span class="mr-2"
                ><i
                  class="mr-3 fa fa-sign-out"
                  style="font-size: 20px; color: white"
                ></i
              ></span>
              <span class="sidenav_list_title"> Logout </span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import LogoUrl from "@/assets/img/logo.svg";
import masterbackgroundUrl from "@/assets/img/retain.jpg";
import configObject from "@/config";
import countryProducts from "@/products";

export default {
  name: "MasterLayout",
  components: {},
  data() {
    return {
      statusInfo: {},
      LogoUrl,
      isViewOnly: false,
      masterbackgroundUrl,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : { name: "COMPANY" },
      companyIcon: null,
      collapseNavbar: true,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      showStationManagementDropDown: false,
      showOurCorporateCustomersDropDown: false,
      showManageExpensesDropDown: false,
      showReportDropDown: false,
      showPeddlingManagementDropDown: false,
      vendors: [],
      usedLang: this.$store.getters.getLanguage,
    };
  },
  watch: {
    collapseNavbar(value) {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      if (value) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
  computed: {
    userName: {
      get() {
        if (localStorage.getItem("userDetails")) {
          return this.userDetails.firstName + "  " + this.userDetails.lastName;
        } else {
          return "Username";
        }
      },
      set(value) {},
    },
  },

  created() {
    if (!localStorage.getItem("userDetails")) {
      this.$router.push({ name: "login" });
    }
    if (localStorage.getItem("companyDetails")) {
      this.companyIcon = this.company.url;
    } else {
      this.companyIcon = null;
    }
    // this.getCompany();
  },
  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    if (this.company.id) {
      this.checkStatus();
    }
    this.checkViewOnly();
    $(".treeview > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        $(".treeview").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
  },
  beforeMount() {
    this.activeRoute = this.$route.name;
  },
  methods: {
    showNotification() {
      const status = this.statusInfo.status;
      if (status == 1) this.showWarningModal();
      if (status == 2) this.showSuspendedModal();
    },
    checkStatus() {
      const modalShown = this.$store.getters.getModalShown;
      if (modalShown) {
        this.statusInfo = this.$store.getters.getStatusInfo;
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/status?companyId=${this.$route.query.companyId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.statusInfo = response.data;
          if (response.data.status == 1) {
            if (
              this.$route.name !== "company_invoice" &&
              this.$route.name !== "invoice_details" &&
              this.$route.name !== "invoice_payments"
            ) {
              this.showWarningModal();
              this.$store.commit("setModalShown", true);
            }
          }
          if (response.data.status == 2) {
            if (
              this.$route.name !== "company_invoice" &&
              this.$route.name !== "invoice_details" &&
              this.$route.name !== "invoice_payments"
            ) {
              this.showSuspendedModal();
            }
          }
          this.$store.commit("setStatusInfo", response.data);
        })
        .catch((error) => {});
    },
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    showSuspendedModal() {
      this.$modal.show("suspendedModal");
    },
    changeCountry(e) {
      this.$store.commit("setCountry", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);

      localStorage.setItem(
        "countryProducts",
        JSON.stringify(countryProducts[e.target.value])
      );
      this.$store.commit("setCountryProducts", countryProducts[e.target.value]);
    },
    changeLanguage(e) {
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },
    checkViewOnly() {
      this.isViewOnly = this.$store.getters.getViewOnly;
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.cMasterLayout.confirmLogout")
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }
        this.$store.commit("setModalShown", false);
        this.$store.commit("setStatusInfo", {});
        this.$store.commit("setBranchModalShown", false);
        this.$store.commit("setBranchStatusInfo", {});

        this.$store.dispatch("logout");
      }
    },
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
    getCompany() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/MyCompanies`,
          configObject.authConfig()
        )
        .then((response) => {
          localStorage.setItem("totalCompanies", JSON.stringify(response.data));
          if (response.data.length > 0) {
            if (!localStorage.getItem("companyDetails")) {
              localStorage.setItem(
                "companyDetails",
                JSON.stringify(response.data[0])
              );
              this.company = response.data[0];
              this.companyIcon = response.data[0].url;
              this.checkStatus();
            }
            this.$eventHub.$emit("gotCompany", true);
          } else {
            this.$eventHub.$emit("gotCompany", false);
            this.$toast.open({
              message: "No company found for this account.",
              type: "error",
              duration: 5000,
            });
          }
        })
        .catch((error) => {
          if (error.message && error.message === "Network Error") {
            this.$toast.open({
              message: "Network Error, Please Check Your Internet Connection",
              type: "error",
              duration: 5000,
            });
          } else {
            // this.$toast.open({
            //   message: "An Error Occured",
            //   type: "error",
            //   duration: 5000
            // });
          }
        });
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ")
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ")
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ")
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ")
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ")
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ")
      );
    },
    toggleCollapsibleNavBar() {
      this.collapseNavbar = !this.collapseNavbar;
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (!this.collapseNavbar) {
        const allListTitles = Array.from(
          document.querySelectorAll(".sidenav_list_title")
        );
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
      } else {
        if (
          document.querySelector(".sidebar").classList.contains("collapsed")
        ) {
          allListTitles.forEach((el) => {
            el.style.display = "none";
          });
        }

        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
      }
    },
    toggleSidenavText() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
      }
    },

    hideTitles() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );

      Array.from(document.querySelectorAll("li")).forEach((li) => {
        li.classList.remove("open");
      });

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
};
</script>
